module.exports = __webpack_public_path__ + "img/pop_img_location_success.91ad247d.png";